export const css = {
    root: 'qA24ZX_U',
    grouphead: '_2fNHrYD1',
    actions: '_2L2L-ybD',
    group: '_3FqDh2ii',
    progress: '_1B-VmzsB',
    toc: '_1xqx793w',
    resource: '_1pIZXuZ6',
    competencyConnection: '_38ciC1OF',
    topicBlock: '_3DQMeLSe',
    titleBlock: '_3zlOhehG',
    title: '_1jkIZsaP',
    close: '_5Qqa4u0X',
    deck: 'U4YvKgoS',
    refTitleBlock: '_3T-WK5wD',
    complete: '_3y8gKGG1',
    incomplete: '_3ePL__kJ',
    refTitle: 'wr3MXg8X',
    fragment: 'YYkEbuTw',
    readButton: 'jqGx0uFy',
    legend: 'ZwNY47lq',
    legendText: '_2rBuzAgd',
    action: 'N3XxYNHh',
    actionIcon: '_2DF7pH9_',
    actionText: 'YiIsVUQg',
    activitycontent: '_1HinZEh1',
    videolink: '_2yGUwu4C',
    cialink: '_3xH9rQMu',
    ciacontent: '_2bnvvoYJ',
    resourcecontent: '_17wggk_O',
    resourcelink: '_1kz4uTSy',
    scorePill: '_2RkCDrdC',
    topicAudio: '_3M76DWAC',
    ' _key': 'afcpe-theme/afcpe/book-widgets/topicgroup'
};
export default css;
